import {Choice, Dialog, Label} from 'platform/components';
import {Space} from 'platform/foundation';

import {CodeResponseBody} from '@dms/api/core';
import i18n from '@dms/i18n';

import {suffixTestId, TestIdProps} from 'shared/web';

interface EditSourceDialogProps extends TestIdProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: () => void;
  selectedSource: string | null;
  sources: CodeResponseBody[] | undefined;
  updateSource: (newSource: string | null) => void;
  apiSource: string | null;
  title?: string;
  label?: string;
  description?: string;
}

export function EditSourceDialog(props: EditSourceDialogProps) {
  const handleSelect = (value: string | null) => {
    props.updateSource(value);
  };

  const sourceOptions = props.sources?.map((source) => ({
    label: source.name,
    value: source.codeId,
  }));

  const isApiSourceSelected = props.selectedSource === props.apiSource;

  return (
    <Dialog
      isOpen={props.isOpen}
      onClose={props.onClose}
      size="small"
      scrollBehavior="outside"
      title={props.title ?? i18n.t('entity.businessCase.labels.sourceDialogTitle')}
      buttons={[
        {variant: 'secondary', onClick: props.onClose, title: i18n.t('general.actions.discard')},
        {
          variant: 'primary',
          onClick: props.onSave,
          title: i18n.t('general.actions.save'),
          isDisabled: !props.selectedSource || isApiSourceSelected,
        },
      ]}
      data-testid={suffixTestId('dialog', props)}
    >
      <Choice
        value={props.selectedSource}
        options={sourceOptions ?? []}
        onChange={handleSelect}
        label={props.label ?? i18n.t('entity.businessCase.labels.source')}
        data-testid={suffixTestId('assignee', props)}
        isNotClearable
      />
      <Space vertical={4} />
      <Label>
        {props.description ?? i18n.t('entity.businessCase.labels.sourceDialogDescription')}
      </Label>
    </Dialog>
  );
}
